import type { RootState } from '@/store';

export const selectConnectionHealth = (state: RootState) => state.connection.health;
export const selectIsInitApiLoading = (state: RootState) => state.connection.isInitApiLoading;
export const selectWsConnection = (state: RootState) => state.connection.isWSConnected;
